/// <reference path="../../common/modals/modals.ts" />

namespace OfficeGuy {
    interface Notification {
        Text: string;
    }

    export class Notifications {
        static Init(): void {
            $(document.body)
                .on("click.notification-remove", "div.og-notification-fixed-remove", function () {
                    var $Notification = $(this).closest(".og-notification-fixed");
                    var Key = "notifications-" + $Notification.data("notificationkey");

                    var $Modal = Modals.Create({
                        Simple: true,
                        Title: "הסתרת התראה",
                        Body: "האם ברצונך להסתיר את ההתראה לשבוע או לתמיד?",
                        Buttons: [
                            $(document.createElement('input'))
                                .addClass("og-button-ui-action og-button-color-submit")
                                .attr("type", "button")
                                .val("הסתרה לשבוע")
                                .on("click", function () {
                                    var Expiration = new Date();
                                    Expiration.setDate(Expiration.getDate() + 7);
                                    Teva.Storage.LocalStorage_Set(Key, Expiration, true);
                                    $Notification.fadeOut({
                                        done: function () {
                                            $Notification.remove();
                                        }
                                    });
                                    Modals.Hide($Modal);
                                }),
                            $(document.createElement('input'))
                                .addClass("og-button-ui-action og-button-color-submit")
                                .attr("type", "button")
                                .val("הסתרה לתמיד")
                                .on("click", function () {
                                    var Expiration = new Date();
                                    Expiration.setMonth(Expiration.getMonth() + 12);
                                    Teva.Storage.LocalStorage_Set(Key, Expiration, true);
                                    $Notification.fadeOut({
                                        done: function () {
                                            $Notification.remove();
                                        }
                                    });
                                    Modals.Hide($Modal);
                                })
                        ]
                    });
                })
                .on("click.notifications", ".og-notification-float", function () {
                    $(this).clearQueue().fadeOut("slow", function () {
                        $(this).remove();
                    });
                });
        }
        static PageLoad(): void {
            Notifications.BindEvents();
        }
        static BindEvents() {
            $(".og-notification-float:not(.og-notification-float-color-proof)")
                .delay(10000)
                .fadeOut("slow", function () {
                    $(this).remove();
                });
            $(".og-notification-float-color-proof")
                .delay(5000)
                .fadeOut("slow", function () {
                    $(this).remove();
                });

            $(".og-notification-fixed-removable").each(function () {
                var $this = $(this);
                var Key = "notifications-" + $this.data("notificationkey");
                var Value = Teva.Storage.LocalStorage_Get(Key, true);
                if (Value != null && new Date(Value) > new Date())
                    $this.remove();
                else
                    $this.show();
            });

            var $FloatContainer = $(".og-notification-float-container");
            if ($FloatContainer.length > 0) {
                if (($(".og-navigation-bar-buttons-primary").length == 0 || $(".og-navigation-bar-buttons-primary").is(":empty")) && $(".og-navigation-bar-buttons-additional").length == 0)
                    $FloatContainer.css("bottom", "0px");
                else
                    $FloatContainer.css("bottom", "");
            }
        }
        static Clear() {
            $(".og-notification-float")
                .clearQueue()
                .fadeOut("slow", function () {
                    $(this).remove();
                });
        }
        static Show(Notifications: Array<Notification>) {
            if (Notifications == null || Notifications.length == 0)
                return;
            OfficeGuy.Notifications.Clear();
            var $Container = $(".og-notification-float-container");
            if ($Container.length == 0) {
                $Container = $(document.createElement('div'))
                    .addClass("og-notification-float-container")
                    .appendTo(document.body);
            }

            for (var i = 0; i < Notifications.length; i++) {
                $(document.createElement('div'))
                    .addClass("og-notification-float")
                    .append($(document.createElement('div')).html(Notifications[i].Text))
                    .appendTo($Container);
            }
            $(".og-notification-float")
                .off("mouseenter.notifications")
                .off("mouseleave.notifications")
                .off("click.notifications");
            OfficeGuy.Notifications.BindEvents();
        }
    }
}

$(document).on("Teva.Init", function () {
    OfficeGuy.Notifications.Init();
});
$(document).on("Teva.PageLoad", function () {
    OfficeGuy.Notifications.PageLoad();
});
